import Headroom from 'headroom.js';

window.Scroller = function () {

  this.init = function () {
    const header = document.querySelector('.main-header');
    const footer = document.querySelector('.main-footer');
    const title = document.querySelector('.main-title--extended');
    const unpinEvent = new CustomEvent('headroomUnpin');

    new Headroom(header, {
      offset: 90,
      classes: {
        unpinned: 'main-header--hide'
      }
    }).init();

    new Headroom(footer, {
      offset: 90,
      classes: {
        unpinned: 'main-footer--hide'
      },
      onUnpin: function () {
        window.dispatchEvent(unpinEvent);
      }
    }).init();

    if (title) {
      new Headroom(title, {
        offset: 90,
        classes: {
          unpinned: 'main-title--hide'
        }
      }).init();
    }
  }
}

new Scroller().init();
